
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24.745","height":"24.745"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_22971","data-name":"Group 22971","transform":"translate(-921.707 513.589)"}},[_c('circle',{attrs:{"id":"Ellipse_289","data-name":"Ellipse 289","cx":"11.872","cy":"11.872","r":"11.872","transform":"translate(922.207 -513.089)","fill":"transparent","stroke":"#959da1","stroke-miterlimit":"10","stroke-width":"1"}}),_c('g',{attrs:{"id":"Group_22817","data-name":"Group 22817","fill":"#959da1"}},[_c('circle',{attrs:{"id":"Ellipse_290","data-name":"Ellipse 290","cx":"1.5","cy":"1.5","r":"1.5","transform":"translate(927.579 -502.717)"}}),_c('circle',{attrs:{"id":"Ellipse_291","data-name":"Ellipse 291","cx":"1.5","cy":"1.5","r":"1.5","transform":"translate(932.579 -502.717)"}}),_c('circle',{attrs:{"id":"Ellipse_292","data-name":"Ellipse 292","cx":"1.5","cy":"1.5","r":"1.5","transform":"translate(937.579 -502.717)"}})])])])
          )
        }
      }
    